import styles from "../../styles/base/Login.module.scss"; 

import logo from "../../assets/base/logo.svg";
import LoginForm from "../../components/base/LoginForm";

import { useState } from "react";
import { useNavigate } from "react-router-dom";

import ForgotPasswordForm from "src/components/base/ForgotPasswordForm";
import ErrorForm from "src/components/base/ErrorForm";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";

import { motion } from "framer-motion";

import { Toaster } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import i18n from "src/i18n";
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "src/components/ui/select";


const languages = ["nl_Nederlands", "fr_Francais", "en_English"]

export default function Login(){
    const {t} = useTranslation()
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const language = useAppSelector(state => state.language);
    const [page, setpage] = useState("");

    //const [isLoadingLogin, setisLoadingLogin] = useState(false);
    const [responseLogin, setresponseLogin] = useState({errorcode:0, message:''});
    const [checkedRemember, setcheckedRemember] = useState(true);

    const [isAnimating, setisAnimating] = useState(false);

    const variants = {
        "login": {},
        "transition_box": {
            duration: 1,
            width: "100vw"
        },
        "transition_image": {
            opacity: 0
        }
    }

    const activateFP = () => {
        setpage("fp")
    }

    const returnFP = () => {
        setpage("")
    }

    const handleChangeLanguage = (lang:string) => {
        i18n.changeLanguage(lang)
    }

    return (
        <>
        <Toaster />
        <div className={styles.n_login}>
            <div className={`${page === "fp" && styles.fp_frm} ${styles.l_form}`}>
                <div className={styles.logo_ct}>
                    <div className={styles.logo_wrapper}>
                        <img className={styles.logo} src={logo} alt="logo"/>
                    </div>
                </div>

                {page === "" && 
                <LoginForm onLogin={(v:any)=>{}} onForgotPassword={()=>{activateFP()}} checkedRemember={checkedRemember} changeCheckedRemember={(v:boolean)=>{setcheckedRemember(v)}}/>
                }

                {page === "fp" &&
                <ForgotPasswordForm onBack={()=>{returnFP()}}/>
                }

                {page === "error" &&
                <ErrorForm error={responseLogin} onBack={()=>{setpage("")}}/>
                }

                <div className={styles.ddl_ct}>
                    <div className={styles.ddl_wrapper}>
                        <div className={styles.ddl}>
                            <Select onValueChange={(v)=>{handleChangeLanguage(v)}} value={i18n.language}>
                                <SelectTrigger><SelectValue/></SelectTrigger>
                                <SelectContent>
                                    <SelectGroup>
                                        <SelectItem value="nl">Nederlands</SelectItem>
                                        <SelectItem value="fr">Français</SelectItem>
                                        <SelectItem value="en">English</SelectItem>
                                    </SelectGroup>
                                </SelectContent>
                            </Select>
                        </div>
                    </div>
                </div>
            </div>

            <motion.div variants={variants} animate={isAnimating ? "transition_box" : ""} className={`${page === "fp" && styles.fp_img} ${styles.r_image}`}>
                <div className={styles.bg_box}>
                    <img className="w-full h-full object-cover" src={"/images/background-puffin-files.jpeg"} />

                    {/* <img className={`${styles.dot} ${styles.dts}`} src={login_dot} alt="dot"/>
                    <img className={`${styles.bubbles} ${styles.dts}`} src={login_bubbles} alt="bubbles"/>
                    <img className={`${styles.dots} ${styles.dts}`} src={login_dots} alt="dots"/> */}

                    {/* <motion.img variants={variants} animate={isAnimating ? "transition_image" : ""} className={styles.phones} src={login_phones} alt="phones"/> */}
                    <motion.div variants={variants} animate={isAnimating ? "transition_image" : ""} className='flex flex-col bg-black/20 w-4/6 backdrop-blur-md rounded-2xl absolute bottom-4 left-4 p-4 text-white'>
                        <p className='font-bold text-lg text-white'>FitDoc</p>
                        <p className='text-sm text-white'>{t("Login.fitdoc_description")}</p>
                    </motion.div>
                </div>
            </motion.div>
        </div>
        </>
    )
}